import {createAction} from '@reduxjs/toolkit';

const CLEAN_CHANGE_REQUEST_INFO = 'CLEAN_CHANGE_REQUEST_INFO';

export const cleanChangeRequestInfo = createAction(CLEAN_CHANGE_REQUEST_INFO);
